import React, { useEffect } from "react"
import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Col, Container, Row } from "react-bootstrap"
import { Parallax } from 'react-scroll-parallax';
import "./marquee.scss"

const Blkmarquee = ({ content }) => {

  return (
    <section className="blk-marquee">
      <Container fluid>
        <Row className={content.block_marquee_id}>
          <Col>
            {content.marquee_title &&
                <Parallax translateX={['70', '-20']}>
                    {content.marquee_title}
                </Parallax>
            }
            {
              content.relationships?.marquee_image &&
              <div className="stamp">
                  <GatsbyImage 
                  image={getImage(content.relationships?.marquee_image?.relationships.field_image.gatsbyImage)} 
                  alt={content.relationships?.marquee_image?.field_image?.alt} 
                  />
              </div>
            }
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export const query = graphql`
  fragment marquee on paragraph__marquee {
    marquee_title
    block_marquee_id
    internal{
        type
    }
    relationships {
      marquee_image {
        field_image {
          alt
        }
        relationships {
          ...getImage
        }
      }
    }
  }
`

export default Blkmarquee
